export default import.meta.ROLLDOWN_FILE_URL_yYXdW5rkm_8kj83UJpHkbQ